import { Component, OnInit } from '@angular/core';
import {MatAccordion} from '@angular/material/expansion';

import { AuthService } from "../../services/firebase/auth.service";
import { DatabaseService } from "../../services/firebase/database.service";
import { SidenavService } from "./../../services/comunication/sidenav.service";
import { concat } from 'rxjs';
import { NoderestapiService } from 'src/app/services/noderestapi.service';
import { ViewChild } from '@angular/core';
import { NgZone } from '@angular/core';



@Component({
	selector: 'app-sidenav',
	templateUrl: './sidenav.component.html',
	styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {
	@ViewChild(MatAccordion) accordion: MatAccordion;
	
	user
	userData
	menuUser
	

	mainMenu = [
		{
			icon: "home", 
			enlace: "/", 
			texto: "Inicio"
		}
	]

	menuAdministrator = [
		{
			icon: "person_add", 
			enlace: "user-create", 
			texto: "Crear Gestor"
		}, 
		{
			icon: "list", 
			enlace: "/table/capturar", 
			texto: "Ver registros"
		}, 
		{
			icon: "list", 
			enlace: "/registros/capturar", 
			texto: "Ver mis registros"
		}, 
		{
			icon: "list", 
			enlace: "/registros/checkboxTodos", 
			texto: "Pasar lista"
		}
	]


	menuGestor = [
		{
			icon: "list", 
			enlace: "/registros/capturar", 
			texto: "Ver mis registros"
		}, 
		{
			icon: "list", 
			enlace: "/registros/checkbox", 
			texto: "Pasar lista"
		}
	]


	menuPorSeccion = []
	menuPorGestor = []
	menuPorColonia = []

	
	constructor(
		private _authService:AuthService, 
		private _databaseService:DatabaseService, 
		private servicioNode: NoderestapiService, 
		public sidenavService:SidenavService,
		private ngZone:NgZone
	) {

		this._authService._auth.onAuthStateChanged(response=>{
			
			this.ngZone.run(()=>{
				console.log("Hay respuesta dentro del modulo landing", response);
				this.user = response

				this.getUserProfile(this.user['uid'])
			});

		})
		
		


		this.servicioNode.traerSecciones().subscribe(data => {
			console.log("servicioNode Traer Secciones recibe: ", data);
			
			for(let item of data['data']) {
				console.log("Iteramdno este item", item)

				let elemento = {
					icon: "list", 
					enlace: "/table-filter/capturar/seccion_electoral/" + item['seccion_electoral'], 
					texto: "Seccion " + item['seccion_electoral']
				}

				this.menuPorSeccion.push(elemento)
			}
		})


		this.servicioNode.traerColoniaComunidad().subscribe(data => {
			
			for(let item of data['data']) {

				let elemento = {
					icon: "list", 
					enlace: "/table-filter/capturar/colonia_comunidad/" + item['colonia_comunidad'], 
					texto: "Poblado:  " + item['colonia_comunidad']
				}

				this.menuPorColonia.push(elemento)
			}
		})

		this.servicioNode.traerNombreRegistrante().subscribe(data => {

			console.log("Traer usuarios tiene", data);
			
			for(let item of data['data']) {

				let elemento = {
					icon: "list", 
					enlace: "/table-filter/capturar/nombre_registrante/" + item['nombre_registrante'], 
					texto: "Usuario:  " + item['nombre_registrante']
				}

				this.menuPorGestor.push(elemento)
			}
		})




		
	}

	ngOnInit(){
		this.getMainMenu()
	}


	getUserProfile(uid){
		// this._databaseService._angularFireDatabase.database.ref('users/'+uid+'/profile').on('value', snapshot => {
		// 	this.userData = snapshot.val()
		// 	this.getmenuAuthor(uid)
		// })

		this.servicioNode.traerUsuario(uid).subscribe(data =>{
			console.log("La data obtenida de API es: ", data['data'][0]);
			this.userData = data['data'][0];
			this.userData['userType'] = data['data'][0]['tipo'];
		})
	}


	getmenuAuthor(uid){
		this._databaseService._angularFireDatabase.database.ref('users/' + uid + '/menu').on('value', snapshot => {
			this.menuUser = snapshot.val()
			// console.log("this.menuAuthor", this.menuAuthor)
		})
	}


	getMainMenu(){

		this._databaseService._angularFireDatabase.database.ref('data/main_menu').on('value', snapshot => {
			this.mainMenu = snapshot.val()
		})

	}
}